import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Question } from "src/app/classes/dynamic-form";
import { DynamicFormService } from "src/app/services/dynamic-form.service";


@Component( {
	selector: "dynamic-form",
	templateUrl: "./dynamic-form.component.html",
	styleUrls: [ './dynamic-form.component.css' ]
})
export class DynamicFormComponent {


	isLoading = true;

	@Input() set categoryId( value: string ) {
		if( value ) this.loadQuestions( value );
	}

	formGroup = new FormGroup( {} );
	questionTree: Question[] = [];

	@Output() submit = new EventEmitter<string>();


	constructor(
		private dynamicFormService: DynamicFormService,
	) {}


	loadQuestions( categoryId: string ) {

		this.dynamicFormService.initialiseForm( this.formGroup, categoryId ).subscribe( questionTree => {
			this.questionTree = questionTree;
      		this.isLoading = false;
		});

	}


	validate() {

		console.log( "fGroup", this.formGroup.valid, this.formGroup.value, JSON.stringify( this.formGroup.value ) );
		this.submit.emit( JSON.stringify( this.formGroup.value ) );

	}


}
